import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateEcommerceID } from "../api/updateEcommApi";

// Async thunk to call the update API
export const updateEcommIdThunk = createAsyncThunk(
  "ecommerce/updateEcommId",
  async ({ ecomm_order_id, reservation_id }, { rejectWithValue }) => {
    try {
      const response = await updateEcommerceID(ecomm_order_id, reservation_id);
      return response.data; // Assuming the API returns relevant data
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const updateEcommIdSlice = createSlice({
  name: "updateEcommId",
  initialState: {
    isLoading: false,
    isSuccess: false,
    error: null,
  },
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateEcommIdThunk.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(updateEcommIdThunk.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(updateEcommIdThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetState } = updateEcommIdSlice.actions;
export const updateEcommIdReducer = updateEcommIdSlice.reducer;
